var $fe0436b1fbfb0a3c$exports = {};
$fe0436b1fbfb0a3c$exports = {
  "collapse": "\u03A3\u03CD\u03BC\u03C0\u03C4\u03C5\u03BE\u03B7",
  "expand": "\u0391\u03BD\u03AC\u03C0\u03C4\u03C5\u03BE\u03B7"
};
export { $fe0436b1fbfb0a3c$exports as default };